type Keys='ASSET_FORM' | 'MAINTENANCE_FORM' | 'ADD_USER_FORM'

export default class LocalStorageService {
    static save<T>(key: Keys, value: T): void {
      try {
        const serialized = JSON.stringify(value);
        localStorage.setItem(key, serialized);
      } catch (error) {
       
      }
    }
  
    static get<T>(key: Keys): T | null {
      try {
        const serialized = localStorage.getItem(key);
        if (!serialized) return null;
        return JSON.parse(serialized) as T;
      } catch (error) {
        return null;
      }
    }
  
    static remove(key: Keys): void {
      try {
        localStorage.removeItem(key);
      } catch (error) {
      }
    }
  
    static clear(): void {
      try {
        localStorage.clear();
      } catch (error) {
      }
    }
  }
  